import Accessibility from "./js/Accessibility";
document.addEventListener('DOMContentLoaded', () => {
    Accessibility.init()
});